import React from 'react';
import {connect} from 'react-redux';

import getUserFacingPolicies from 'auth/getUserFacingPolicies';
import {getAdminDataPolicy, getDefaultDataPolicy} from 'auth/IntrinsicPolicies';
import {Collaborator, Owner, OwnerInfo, PolicyType} from 'auth/PermissionConstants';
import {DataPolicy} from 'auth/PolicyConstants';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import CollaboratorsFormGroup from 'collaborator-components/CollaboratorsFormGroup';
import CollaboratorsSection from 'collaborator-components/CollaboratorsSection';
import {Collaboration} from 'collaborator-components/useCollaborationManagementState';
import {BenchlingState} from 'redux-stores/reduceApp';

function mapStateToProps(state: BenchlingState): {dataPolicies: Array<DataPolicy>} {
  return {
    dataPolicies: getUserFacingPolicies(state.models.policies.dataPolicies!),
  };
}

export interface UpdateArgs {
  collaborators?: Array<Collaborator>;
  collaborations?: Array<Collaboration>;
  ownerInfo?: OwnerInfo;
  owner?: Owner;
}

export interface ConnectedProps {
  dataPolicies: Array<DataPolicy>;
}

export interface OwnableCollaboratorsSectionProps {
  collaborators: Array<Collaborator>;
  enableAuditors?: boolean;
  isReadOnly: boolean;
  onLeave?: (partyId: string) => void;
  onUpdate: (updateArgs: UpdateArgs) => void;
  ownableId?: string | null;
  owner: Owner;
  ownerInfo: OwnerInfo;
}
function _getAdminDataPolicyId(dataPolicies: Array<DataPolicy>): string {
  return getAdminDataPolicy(dataPolicies).id;
}

function _getDefaultDataPolicyId(dataPolicies: Array<DataPolicy>): string {
  return getDefaultDataPolicy(dataPolicies).id;
}

export function OwnableCollaboratorsSection({
  enableAuditors = false,
  ...props
}: OwnableCollaboratorsSectionProps & ConnectedProps): JSX.Element {
  const existingCollaboratorIds = props.collaborators.map((c) => c.id);
  existingCollaboratorIds.push(props.owner.id);

  return (
    <CollaboratorsSection
      getAdminPolicyId={_getAdminDataPolicyId}
      getDefaultPolicyId={_getDefaultDataPolicyId}
      collaborators={props.collaborators}
      policies={props.dataPolicies}
      isReadOnly={props.isReadOnly}
      enableAuditors={enableAuditors}
      policeableId={props.ownableId}
      onLeave={props.onLeave}
      onUpdate={props.onUpdate}
      owner={props.owner}
      ownerInfo={props.ownerInfo}
      policyType={PolicyType.DATA}
    />
  );
}

export default connect(mapStateToProps)(OwnableCollaboratorsSection);
